import { render, staticRenderFns } from "./PartnerIdentificationData.vue?vue&type=template&id=a9e975e6"
import script from "./PartnerIdentificationData.vue?vue&type=script&lang=js"
export * from "./PartnerIdentificationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports